import { useState } from "react";

const Calculator = ({ darkMode }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [calculator, setCalculator] = useState({
    chargebacks: "",
    rdrCount: "",
    totalTransactionCount: "",
    disputeRatio: 0,
  });

  const handleCopy = () => {
    navigator.clipboard.writeText(calculator.disputeRatio).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };
  const handleCalculatorChange = (value, property) => {
    setCalculator((prev) => {
      const updated = {
        ...prev,
        [property]: value,
      };

      const chargebacks = parseFloat(updated.chargebacks) || 0;
      const rdrCount = parseFloat(updated.rdrCount) || 0;
      const total = parseFloat(updated.totalTransactionCount);

      const disputeRatio =
        total && total > 0 ? ((chargebacks + rdrCount) / total) * 100 : 0;

      return {
        ...updated,
        disputeRatio: parseFloat(disputeRatio.toFixed(2)),
      };
    });
  };

  return (
    <div
      className={`shadow-lg rounded-lg p-6 w-[450px] ${
        darkMode ? "bg-gray-800" : "bg-white"
      }`}
    >
      <h1 className="text-xl font-bold mb-4">
        Dispute Calculator
      </h1>
      <div className="mb-4">
        <label htmlFor="chargebacks" className="block mb-2">
          Chargebacks count
        </label>
        <input
          type="number"
          id="chargebacks"
          value={calculator.chargebacks}
          onChange={(e) =>
            handleCalculatorChange(e.target.value, "chargebacks")
          }
          placeholder="Enter chargebacks count"
          className={`w-full px-4 py-2 rounded-md focus:outline-hidden focus:ring-2 ${
            darkMode
              ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-400"
              : "bg-gray-100 text-gray-900 border-gray-300 focus:ring-blue-500"
          }`}
        />
      </div>
      <div className="mb-4">
        <label htmlFor="rdrCount" className="block mb-2">
          RDR Count
        </label>
        <input
          type="number"
          id="rdrCount"
          value={calculator.rdrCount}
          onChange={(e) => handleCalculatorChange(e.target.value, "rdrCount")}
          placeholder="Enter RDR count"
          className={`w-full px-4 py-2 rounded-md focus:outline-hidden focus:ring-2 ${
            darkMode
              ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-400"
              : "bg-gray-100 text-gray-900 border-gray-300 focus:ring-blue-500"
          }`}
        />
      </div>
      <div className="mb-4">
        <label htmlFor="totalTransactionCount" className="block mb-2">
          Total Transactions Count
        </label>
        <input
          type="number"
          id="totalTransactionCount"
          value={calculator.totalTransactionCount}
          onChange={(e) =>
            handleCalculatorChange(e.target.value, "totalTransactionCount")
          }
          placeholder="Enter total transactions count"
          className={`w-full px-4 py-2 rounded-md focus:outline-hidden focus:ring-2 ${
            darkMode
              ? "bg-gray-700 text-gray-200 border-gray-600 focus:ring-blue-400"
              : "bg-gray-100 text-gray-900 border-gray-300 focus:ring-blue-500"
          }`}
        />
      </div>
      <div className="flex items-center gap-2">
        <p>
          <strong>Dispute Ratio (%):</strong>{" "}
          {calculator.disputeRatio.toFixed(2)}%
        </p>
        <button
          onClick={handleCopy}
          className={`px-2 py-1 border rounded-md text-sm focus:outline-hidden focus:ring-2 ${
            darkMode
              ? "text-white border-white hover:bg-gray-900"
              : "text-gray-800 border-gray-800 hover:bg-gray-400"
          }`}
        >
          Copy
        </button>
      </div>
      {copySuccess && (
        <p className="mt-2 text-green-500 text-sm">Copied to clipboard!</p>
      )}
    </div>
  );
};

export default Calculator;
